import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import Homes from './components/Homes';

const homes = (props,{ t }) => (
  <Container>
    <Homes {...props} />
  </Container>
);

homes.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(homes);
